import AnimatedBackground from '@/app/shared/components/AnimatedBackground';
import type { LoginPanelProps } from '@/platform/app/contracts';

export interface DefaultLoginPanelProps extends LoginPanelProps {
  title: string;
  subtitle: string;
}

/**
 * The platform's login side panel: the animated brand gradient with the
 * marketing title and subtitle. A brand replaces it through `brand.LoginPanel`.
 */
export const DefaultLoginPanel = ({
  controls,
  lockup,
  title,
  subtitle,
}: DefaultLoginPanelProps) => (
  <AnimatedBackground saturationFactor={0.1}>
    <div className="flex w-full h-screen items-center py-5 flex-col">
      <div className="flex w-full justify-end px-5 gap-2 animate-fade-down">
        {controls}
      </div>
      <div className="flex flex-col gap-10 justify-center h-full max-w-2xl 2xl:px-5 px-20">
        <span className="animate-fade-left font-outfit font-bold 2xl:text-5xl text-4xl text-white drop-shadow-md selection:bg-tk-brand-600/50 selection:text-white">
          {title}
        </span>
        <span className="animate-fade-left font-poppins font-medium 2xl:text-2xl text-xl text-white drop-shadow-md selection:bg-tk-brand-600/50 selection:text-white">
          {subtitle}
        </span>
      </div>
      <div className="mb-10 animate-fade-up">{lockup}</div>
    </div>
  </AnimatedBackground>
);
